import { isEmpty } from 'lodash';
import { useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useAppSelector } from 'hooks/redux';
import { ReactComponent as GlanceSVG } from 'images/employee/glance.svg';
import SubmitButton from 'components/buttons/SubmitButton/SubmitButton';
import { getText } from 'utils/stringUtil';
import { GET_STARTED, LOG_OUT } from 'constants/languageConstants';
import {
  logoutUser,
  resetAuthState,
  setWhoAmI,
  whoamI,
} from 'modules/auth/slices/employeeAuthSlice';
import {
  getIDCardData,
  getPublishedPlans,
  resetIDcardState,
  setOnboardingView,
} from 'modules/auth/slices/idCardSlice';
import { PLAN_VIEW } from 'modules/auth/constants/authConstants';

import styles from './onBoarding.module.less';

const OnBoarding = () => {
  const dispatch = useDispatch();
  const { currentEmployee, inProgress } = useAppSelector(
    (state) => state.idCard
  );
  const { benguide } = useAppSelector((state) => state);
  const { data: benguideData } = benguide;
  const {
    hasElection,
    hasPlans,
    hasDBGPlans = false,
  } = useAppSelector((state) => state.idCard.electionData) || {};
  const whoAmI = useAppSelector((state) => state.employeeAuth.whoami);
  const language = useAppSelector((state) => state.benguide.data?.language);
  const urlHash = useAppSelector((state) => state.benguide.data.urlHash);

  useEffect(() => {
    dispatch(getPublishedPlans(currentEmployee?.employerId));

    if (!!hasElection && !hasPlans) {
      dispatch(
        getIDCardData(
          currentEmployee?.individualId,
          currentEmployee?.employerId,
          benguideData?.planYearId
        )
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentEmployee, hasElection]);

  useEffect(() => {
    dispatch(whoamI());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (!isEmpty(whoAmI) && !whoAmI?.isTermsAccepted) {
      dispatch(setOnboardingView(PLAN_VIEW.TERMS.type));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [whoAmI]);

  const handleNext = () => {
    if (hasDBGPlans) {
      dispatch(setOnboardingView(PLAN_VIEW.MEDICAL.type));
    } else {
      handleLogout();
    }
  };

  const handleLogout = () => {
    dispatch(resetAuthState());
    dispatch(resetIDcardState());
    dispatch(setWhoAmI({}));
    dispatch(logoutUser(urlHash));
  };

  return (
    <div className={styles.container}>
      <GlanceSVG className={styles.displayImage} />
      <SubmitButton
        type="primary"
        htmlType="button"
        loading={inProgress}
        onClick={() => handleNext()}
        className={styles.submitPwdButton}
      >
        {hasDBGPlans
          ? getText(GET_STARTED, language)
          : getText(LOG_OUT, language)}
      </SubmitButton>
    </div>
  );
};

export default OnBoarding;
